import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './fahrzeug.list-view.html',
    styleUrls: ['./fahrzeug.list-view.scss']
})
export class FahrzeugListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
